export default {
	"coupon.TheCouponHasExpiredAndTheCampaignIsInvalid": "The coupon has expired and the campaign is invalid"
}